export const AUTH_PROVIDERS = {
  TOTEAT: 'toteat',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
} as const

export type AuthProvider = (typeof AUTH_PROVIDERS)[keyof typeof AUTH_PROVIDERS]

export const AUTH_PROVIDER_CODES = {
  1: AUTH_PROVIDERS.FACEBOOK,
  2: AUTH_PROVIDERS.GOOGLE,
} as const

export const POPUP_CHECK_INTERVAL_MS = 500

export const MS_PER_SECOND = 1000

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  LOGGED_USER: 'usuarioLogueado',
  EMAIL: 'em',
  TOT0: 'tot0',
  TOT2: 'tot2',
  LOGIN_TYPE: 'tot3',
} as const
